module.exports = __webpack_public_path__ + "img/尊享功能-灰.c71dc7d8.png";